import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Tooltip } from '@material-ui/core';
import { v4 as uuid } from 'uuid';
import { Alert, Collapse } from 'reactstrap';
import { Field } from 'redux-form';
import Header from './Header';
import { onShowAlert } from '../../../shared/utils/smartutils';
import { EVALUATION_HEADER_TYPE } from '../../../shared/utils/constants';

const EvaluativeActivitiesGridMaintenance = (props) => {
  const {
    t,
    evaluationClosingWrapper,
    dto,
    notificationAlert,
    setNotificationAlert,
    change,
  } = props;

  const [consolidationWrapper, setConsolidationWrapper] = useState({});

  const validateRangeGrade = (item, wrapper, evaluationIndex) => {
    const updatedItem = item;
    if (
      updatedItem.average > wrapper.maxGrade ||
      wrapper.average < updatedItem.minGrade
    ) {
      onShowAlert(
        'danger',
        t('errors.title'),
        t('notifications.outside-average-range'),
        setNotificationAlert
      );
      updatedItem.evaluations[evaluationIndex].grade = '';
      updatedItem.average = updatedItem.averageCopy;
    }
  };

  const getAverage = (evt, item) => {
    const updatedItem = item;
    updatedItem.classCouncil = Number(evt.target.value);
    const updatedFinalAverage =
      updatedItem.averageCopy + updatedItem.classCouncil;
    updatedItem.average = Number(updatedFinalAverage.toFixed(2));
  };

  const changeAverage = (evt, item, wrapper, evaluationIndex, index) => {
    const updatedItem = { ...item };
    getAverage(evt, updatedItem);
    updatedItem.evaluations[evaluationIndex].grade = Number(evt.target.value);
    validateRangeGrade(updatedItem, wrapper, evaluationIndex);
    const updatedConsolidationWrapper = { ...consolidationWrapper };
    updatedConsolidationWrapper.closingData[index] = updatedItem;
    setConsolidationWrapper(updatedConsolidationWrapper);
  };

  const studentsColumn = (data) => {
    return (
      <div className="evaluative-activities-grid-row flex-column">
        {data && (
          <>
            <div className="student-box-header">
              <span className="student-name">{t('general.student')}</span>
            </div>
            {data.map((item) => (
              <div
                key={item.studentId}
                className="student-box tooltip-test"
                title={`${item.studentName} - ${item.studentId}`}
              >
                <span className="student-name">{item.studentName}</span>
              </div>
            ))}
          </>
        )}
      </div>
    );
  };

  const getColor = (evaluation, wrapper) => {
    const color = 'success';
    if (
      evaluation.evaluationId &&
      evaluation.correctionId &&
      evaluation.grade >= wrapper.minAverage
    ) {
      return color;
    }
    if (!evaluation.evaluationId) {
      return color;
    }
    return 'danger';
  };

  const getColorAverage = (average, minAverage) => {
    return average >= minAverage ? 'average-success' : 'average-danger';
  };

  const fieldPill = (evaluation, wrapper) => {
    return (
      <div key={uuid()} className="evaluation-box divider">
        <span className={`pill ${getColor(evaluation, wrapper)}`}>
          {evaluation.correctionId && evaluation.grade !== null
            ? evaluation.grade
            : '--'}
        </span>
      </div>
    );
  };
  const fieldClassCouncil = (
    evaluation,
    item,
    wrapper,
    evaluationIndex,
    index
  ) => {
    return (
      <div className="evaluation-box divider">
        <input
          type="number"
          className="pill class-council success"
          value={item.classCouncil ? item.classCouncil : null}
          min="0"
          max="100"
          disabled={dto.cycleClosed}
          step="0.01"
          onChange={(evt) =>
            changeAverage(evt, item, wrapper, evaluationIndex, index)
          }
        />
      </div>
    );
  };

  const fieldAverage = (evaluation, item, wrapper) => {
    return (
      <div key={uuid()} className="evaluation-box">
        <span
          className={`pill ${getColorAverage(
            item.average,
            wrapper.minAverage
          )}`}
        >
          {item.average || '--'}
        </span>
      </div>
    );
  };

  const getField = (evaluation, item, wrapper, evaluationIndex, index) => {
    switch (evaluation.evaluationDateKey) {
      case EVALUATION_HEADER_TYPE.COUNCIL:
        return fieldClassCouncil(
          evaluation,
          item,
          wrapper,
          evaluationIndex,
          index
        );
      case EVALUATION_HEADER_TYPE.AVERAGE:
        return fieldAverage(evaluation, item, wrapper);
      default:
        return fieldPill(evaluation, wrapper);
    }
  };

  useEffect(() => {
    change('evaluativeActivitiesGrid', consolidationWrapper);
  }, [consolidationWrapper]);

  useEffect(() => {
    setConsolidationWrapper(evaluationClosingWrapper);
  }, [evaluationClosingWrapper]);

  const getHeaderTitle = (title) => {
    const [key, evaluationTitle] = title.split('-');

    return (
      <>
        <span>{key}</span>
        {evaluationTitle && (
          <span className="text-truncate w-100">{evaluationTitle}</span>
        )}
      </>
    );
  };

  return (
    <>
      <Header cycleName={dto.cycleName} subjectName={dto.subject.name} />
      <Field
        name="errors"
        component={(field) => (
          <Collapse isOpen={!!field.meta.error} className="width100 mb-2">
            <Alert className="text-center mb-0" color="danger">
              {field.meta.error}
            </Alert>
          </Collapse>
        )}
      />
      <Collapse isOpen={notificationAlert.status} className="width100">
        <Alert className="text-center" color={notificationAlert.color}>
          {t(notificationAlert.message)}
        </Alert>
      </Collapse>
      <div className="form__form-group">
        <div className="evaluative-activities-grid-container">
          {studentsColumn(evaluationClosingWrapper.closingData)}
          <div className="wrapper-info">
            <div className="evaluation-box-container">
              {evaluationClosingWrapper &&
                evaluationClosingWrapper.headers &&
                evaluationClosingWrapper.headers.map((item) => (
                  <div key={item.header} className="evaluation-box-header">
                    <Tooltip title={item.evaluationTitles || ''}>
                      <div className="student-name d-flex flex-column align-items-center">
                        {getHeaderTitle(item.header)}
                      </div>
                    </Tooltip>
                  </div>
                ))}
            </div>
            {evaluationClosingWrapper &&
              evaluationClosingWrapper.closingData &&
              evaluationClosingWrapper.closingData.map((item, index) => (
                <div key={item.studentId} className="evaluation-box-container">
                  {item.evaluations.map((evaluation, evaluationIndex) => (
                    <Fragment key={`${evaluation}-${evaluationIndex + index}`}>
                      {getField(
                        evaluation,
                        item,
                        evaluationClosingWrapper,
                        evaluationIndex,
                        index
                      )}
                    </Fragment>
                  ))}
                </div>
              ))}
          </div>
        </div>
      </div>
    </>
  );
};

EvaluativeActivitiesGridMaintenance.propTypes = {
  t: PropTypes.func.isRequired,
  evaluationClosingWrapper: PropTypes.shape(PropTypes.shape).isRequired,
  setNotificationAlert: PropTypes.func.isRequired,
  notificationAlert: PropTypes.shape(PropTypes.shape).isRequired,
  dto: PropTypes.shape(PropTypes.shape).isRequired,
  change: PropTypes.func.isRequired,
};

export default withTranslation('common')(EvaluativeActivitiesGridMaintenance);
